import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }

import NavAndTitleBar from '@/components/NavAndTitleBar.vue';
import Alert from '@/components/AlertNotification.vue';
import { onErrorCaptured, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const errorCaptured = ref(false);

onErrorCaptured((err, instance, info) => {
  errorCaptured.value = true;
  console.error(info);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(NavAndTitleBar),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    })),
    (errorCaptured.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, "An error occurred."))
      : _createCommentVNode("", true),
    _createVNode(Alert)
  ], 64))
}
}

})